<app-background-card
  *transloco="let t"
  titleTestId="user-invitation-template-list-title"
  testId="user-invitation-template-list-card"
>
  @if (projectUserService.loading()) {
    <app-loading />
  } @else {
    <p-table
      [value]="rolesList()"
      [tableStyle]="{'min-width': '50rem'}"
      data-testid="user-invitation-template-table"
    >
      <ng-template #header>
        <tr>
          <th
            pSortableColumn="userRole"
            data-testid="user-invitation-template-role-header"
            scope="col"
          >
            {{ t('userManagement.invitationTemplate.userRole') }}
            <p-sortIcon field="userRole"></p-sortIcon>
          </th>
          <th aria-roledescription="action" scope="col"></th>
        </tr>
      </ng-template>
      <ng-template #body let-role>
        <tr>
          <td data-testid="user-invitation-template-role-cell">{{ role.translation }}</td>
          <td [style]="{width: '72px'}">
            <p-button
              icon="pi pi-pencil"
              class="p-button-rounded"
              severity="secondary"
              (click)="onEditTemplateClick(role)"
              (keydown.enter)="onEditTemplateClick(role)"
              data-testid="user-invitation-template-edit-button"
            ></p-button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</app-background-card>

<app-user-invitation-template-dialog [projectId]="project.id" />
